import React, { useMemo, useState } from 'react'

import { ModalContext } from '../../../lib/hooks/useModal'

import { ModalContextValue, ModalData, ModalName, ModalPayload } from '../../../types'

type ModalProviderProps = {
  /** Children React Components, most likely the App component */
  children: React.ReactNode
}

const ModalProvider = ({ children }: ModalProviderProps) => {
  const [modalPayload, setModalPayload] = useState<ModalPayload | null>(null)
  // memo the callback events separately, otherwise we'll instantiate new callbacks
  // whenever the payload changes and cause issues with useEffect
  const events = useMemo<ModalContextValue>(() => {
    const showModal = (name: ModalName, data?: ModalData) => setModalPayload({ name, data })
    const hideModal = () => setModalPayload(null)
    return { modalPayload: null, showModal, hideModal }
  }, [setModalPayload])
  const contextValue = useMemo<ModalContextValue>(() => {
    const { showModal, hideModal } = events
    return { modalPayload, showModal, hideModal }
  }, [modalPayload, events])
  return <ModalContext.Provider value={contextValue}>{children}</ModalContext.Provider>
}

export default ModalProvider
